<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <ng-container *ngIf="config.display_type == 'dropdowns'">
        <!-- Cấu hình ngôn ngữ đã chọn -->
        <p class="title-config">{{'ngon_ngu_da_chon' | translate}}</p>
  
        <div class="config-name mb-4">
          <p>{{'flag' | translate}}</p>
          <nz-switch [(ngModel)]="config.toggle.flag.disable" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
  
        <div class="config-name mb-4">
          <p>{{'noi_dung' | translate}}</p>
          <nz-switch [(ngModel)]="config.toggle.content.disable" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
  
        <div class="config-name mb-4">
          <p>{{'Icon' | translate}}</p>
          <nz-switch [(ngModel)]="config['icon']['disable']" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
  
        <!-- Cấu hình hộp thoại -->
        <p class="title-config">{{'cau_hinh_hop_thoai' | translate}}</p>
        <div class="config-name mb-4">
          <p>{{'flag' | translate}}</p>
          <nz-switch [(ngModel)]="config.modal.flag.disable" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
  
        <div class="config-name mb-4">
          <p>{{'noi_dung' | translate}}</p>
          <nz-switch [(ngModel)]="config.modal.content.disable" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
      </ng-container>
      <ng-container *ngIf="config.display_type == 'list'">
        <div class="config-name mb-4">
          <p>{{'flag' | translate}}</p>
          <nz-switch [(ngModel)]="config.toggle.flag.disable" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>

        <div class="config-name mb-4">
          <p>{{'noi_dung' | translate}}</p>
          <nz-switch [(ngModel)]="config.toggle.content.disable" 
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của multi-language-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}"
        [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')"
      >
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>

      <!-- Cấu hình kiểu hiển thị -->
      <mat-form-field>
        <mat-label>{{ 'kieu_hien_thi' | translate }}</mat-label>
        <mat-select [value]="config.display_type"
          [ngModel]="config.display_type" 
          (ngModelChange)="config.display_type = $event"
          (nzOnAfterChange)="handleDisplayType($event)">
          <mat-option *ngFor="let item of displayType" [value]="item.type">{{ item.name | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Cấu hình chung-->
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}"
        [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')"
      >
        <div *ngIf="!config.display_type || config.display_type == 'dropdowns'" class="editor-field">
          <!-- Quản lý dữ liệu ở trang Admin -->
          <div nz-submenu nzTitle="{{'vi_tri_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu1" (nzOpenChange)="openHandler('submenu1')">
            <div class="config-row mt-2">
              <p class="mb-3">{{'vi_tri' | translate}}</p>
              <nz-radio-group [(ngModel)]="config.modal.position" (ngModelChange)="updateDistance()">
                <label nz-radio nzValue="top">{{'duoi' | translate}}</label>
                <label nz-radio nzValue="bottom">{{'tren' | translate}}</label>
                <label nz-radio nzValue="left">{{'phai' | translate}}</label>
                <label nz-radio nzValue="right">{{'trai' | translate}}</label>
              </nz-radio-group>
            </div>
            <div class="d-flex flex-row justify-content-between align-items-center">
              <p style="margin:0">{{'khoang_cach' | translate}}:</p>
              <nz-input-number [(ngModel)]="config.modal.distance" (nzBlur)="updateDistance()"></nz-input-number>
            </div>
          </div>
          <ng-container>
            <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMapSub.submenu24" (nzOpenChange)="openHandler('submenu24')">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['multi-language']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'right' },
                  { type: 'left' }
                ]">
              </app-padding-config>
            </li>
          </ng-container>
        </div>

        <ng-container *ngIf="config.display_type == 'list'">
          <div nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMapSub.submenu2" (nzOpenChange)="openHandler('submenu2')">
            <div class="color-pick">
              <span class="title w-50">{{'mau_nen' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['multi-language']['background-color']"
                [style.background]="class['multi-language']['background-color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['toggle'].gradient_check"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
              />
            </div>
            <div class="mr-2 mb-3 mt-3 view-more" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 7px;
              ">
              <p class="discover_text" (click)="openViewAll(styles_field[0])"
                style="cursor: pointer; text-align: left; margin: 0">
                {{'mo_rong' | translate}} &#8594;
              </p>
            </div>
          </div>
          <!-- Cấu hình hình dạng viền -->
          <div nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMapSub.submenu3" (nzOpenChange)="openHandler('submenu3')">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['multi-language']" [id_object]="objectChoosing._id">
            </app-borders-config>

            <!-- Nút mở rộng -->
            <div class="item-border my-3" style="float: right">
              <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
                {{'mo_rong' | translate}} &#8594;
              </p>
            </div>
          </div>
          <!-- Khoảng đệm -->
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMapSub.submenu19" (nzOpenChange)="openHandler('submenu19')">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['multi-language']" [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'right' },
                { type: 'left' }
              ]">
            </app-padding-config>
          </li>
          <!-- Cấu hình đổ bóng -->
          <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu13" (nzOpenChange)="openHandler('submenu13')">
            <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['multi-language']"
              [shadowConfig]="config.toggle['box-shadow']" [objectChoosing]="objectChoosing">
            </app-shadow-config>
          </li>
        </ng-container>
      </li>

      <!-- Danh sách thả xuống -->
      <ng-container *ngIf="!config.display_type || config.display_type == 'dropdowns'">
        <!-- Cấu hình ngôn ngữ được chọn-->
        <li nz-submenu nzTitle="{{'ngon_ngu_da_chon' | translate}}"
          [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')"
        >
          <div class="editor-field">
            <!-- Cấu hình màu nền của button -->
            <div nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMapSub.submenu2" (nzOpenChange)="openHandler('submenu2')">
              <div class="color-pick">
                <span class="title w-50">{{'mau_nen' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['multi-language']['background-color']"
                  [style.background]="class['multi-language']['background-color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['toggle'].gradient_check"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
                />
              </div>
              <div class="mr-2 mb-3 mt-3 view-more" style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  gap: 7px;
                ">
                <p class="discover_text" (click)="openViewAll(styles_field[0])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </div>
            <!-- Cấu hình hình dạng viền -->
            <div nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMapSub.submenu3" (nzOpenChange)="openHandler('submenu3')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['multi-language']" [id_object]="objectChoosing._id">
              </app-borders-config>

              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </div>
            <!-- Cấu hình đổ bóng -->
            <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu13" (nzOpenChange)="openHandler('submenu13')">
              <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['multi-language']"
                [shadowConfig]="config.toggle['box-shadow']" [objectChoosing]="objectChoosing">
              </app-shadow-config>
            </li>

            <div nz-submenu nzTitle="{{'dinh_dang_noi_dung' | translate}}" [(nzOpen)]="openMapSub.submenu4" (nzOpenChange)="openHandler('submenu4')">
              <div class="config-name mb-4">
                <p>{{'flag' | translate}}</p>
                <nz-switch [(ngModel)]="config.toggle.flag.disable" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>
      
              <div class="config-name mb-4">
                <p>{{'noi_dung' | translate}}</p>
                <nz-switch [(ngModel)]="config.toggle.content.disable" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>

              <ng-container *ngIf="config.toggle.content.disable" >
                <div class="config-name">
                  <!-- Font-family -->
                  <div style="width:65%">
                    <mat-form-field>
                      <mat-label>Font</mat-label>
                      <mat-select [(value)]="class['multi-language__content']['font-family']"
                        [(ngModel)]="class['multi-language__content']['font-family']" 
                        (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div style="width:35%">
                    <mat-form-field >
                      <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                      <input matInput type="number" 
                        [ngModel]="class['multi-language__content']['font-size'] | vhnumber"
                        (ngModelChange)="class['multi-language__content']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'kieu_chu' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button 
                      [nzType]="class['multi-language__content']['font-weight'] == 'bold' ? 'primary': 'default'" 
                      (click)=" class['multi-language__content']['font-weight'] = class['multi-language__content']['font-weight'] == 'bold' ? '400' : 'bold'; updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                      [nzType]="class['multi-language__content']['font-style'] == 'italic'? 'primary': 'default'" 
                      (click)="class['multi-language__content']['font-style'] = class['multi-language__content']['font-style'] == 'normal' ? 'italic': 'normal'; updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                      [nzType]="class['multi-language__content']['text-decoration'] == 'underline'? 'primary': 'default'" 
                      (click)="class['multi-language__content']['text-decoration'] = class['multi-language__content']['text-decoration'] == 'none' ? 'underline': 'none'; updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button 
                      [nzType]="class['multi-language__content']['text-transform'] == 'uppercase'? 'primary': 'default'" 
                      (click)="class['multi-language__content']['text-transform'] = class['multi-language__content']['text-transform'] == 'none' ? 'uppercase': 'none'; updateClass()">
                      <span>AB</span>
                    </button>
                    <!-- Màu chữ -->
                    <div>
                      <input id="color" type="button" 
                        [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                        [cpOKButton]="true" 
                        [(colorPicker)]="class['multi-language__content']['color']"
                        [style.background]="class['multi-language__content']['color']"
                        (colorPickerClose)="updateClass()" />
                    </div>
                  </div>
                </div>
                <!-- Canh lề -->
                <div class="my-4">
                  <p>{{'canh_le' | translate}}</p>
                  <div class="font">
                    <!-- Lề trái -->
                    <button nz-button class="align-button" title="flex-start" 
                      [nzType]="class['multi-language__content']['text-align'] === 'left'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__content']['text-align'] = 'left'; updateClass()">
                      <i nz-icon nzType="align-left" nzTheme="outline"></i>
                    </button>
                    <!-- Canh giữa -->
                    <button nz-button class="align-button" title="center"
                      [nzType]="class['multi-language__content']['text-align'] === 'center'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__content']['text-align'] = 'center'; updateClass()">
                      <i nz-icon nzType="align-center" nzTheme="outline"></i>
                    </button>
                    <!-- Lề phải -->
                    <button nz-button class="align-button" title="flex-end"
                      [nzType]="class['multi-language__content']['text-align'] === 'right'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__content']['text-align'] = 'right'; updateClass()">
                      <i nz-icon nzType="align-right" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>

            <div nz-submenu nzTitle="{{'bieu_tuong_truoc' | translate}}" [(nzOpen)]="openMapSub.submenu15" (nzOpenChange)="openHandler('submenu15')">
              <div class="config-name mb-4">
                <p>{{'Icon' | translate}}</p>
                <nz-switch [ngModel]="config['icon_before']?.['disable']" 
                  (ngModelChange)="config['icon_before']['disable'] = $event; updateObject()">
                </nz-switch>
              </div>
              <ng-container *ngIf="config['icon_before']?.['disable']" >
                <div class="config-name mb-4">
                  <mat-icon>{{ config['icon_before']['name'] }}</mat-icon>
                  <button nz-button nzType="default" style="border-radius: 5px" 
                    (click)="openDialogChooseIcon()"
                    [disabled]="!config['icon_before']['disable']">
                    {{'thay_doi' | translate}}
                  </button>
                </div>
                <!-- Kích thước icon -->
                <div class="mb-4">
                  <div class="config-name">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="50"
                      [nzDisabled]="!config['icon_before']['disable']"
                      [ngModel]="class['multi-language__icon--before']?.['font-size'] | vhnumber" 
                      (ngModelChange)="
                        class['multi-language__icon--before']['font-size'] = $event + 'px';
                        class['multi-language__icon--before'].width = $event + 'px';
                        class['multi-language__icon--before'].height = $event + 'px'
                      " 
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <div>
                    <nz-slider [nzMin]="10" [nzMax]="50" 
                      [nzDisabled]="!config['icon_before']['disable']"
                      [ngModel]="class['multi-language__icon--before']?.['font-size'] | vhnumber" 
                      (ngModelChange)="
                        class['multi-language__icon--before']['font-size'] = $event + 'px';
                        class['multi-language__icon--before'].width = $event + 'px';
                        class['multi-language__icon--before'].height = $event + 'px'
                      "
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                </div>
                <!-- Màu sắc icon -->
                <div class="config-name">
                  <p>{{'mau_sac' | translate}}</p>
                  <div>
                    <input class="input-color" type="button"
                      [cpOKButton]="true" 
                      [disabled]="!config['icon_before']['disable']"
                      [style.background]="class['multi-language__icon--before']['color']"
                      [(colorPicker)]="class['multi-language__icon--before']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
                <!-- Khoảng cách giữa chữ và lá cờ với biểu tượng -->
                <div *ngIf="config.toggle.flag.disable || config.toggle.content.disable"
                class="d-flex flex-row justify-content-between align-items-center mb-2">
                  <p style="margin:0">{{ 'khoang_cach_giua_chu_va_la_co_so_voi_bieu_tuong' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['multi-language__toggle']['gap'] | vhnumber"
                    (ngModelChange)="class['multi-language__toggle']['gap'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
              </ng-container>
            </div>

            <div nz-submenu nzTitle="{{'icon' | translate}}" [(nzOpen)]="openMapSub.submenu5" (nzOpenChange)="openHandler('submenu5')">
              <div class="config-name mb-4">
                <p>{{'Icon' | translate}}</p>
                <nz-switch [(ngModel)]="config['icon']['disable']" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>
              <ng-container *ngIf="config['icon']['disable']" >
                <div class="config-name mb-4">
                  <mat-icon>{{ config['icon']['name'] }}</mat-icon>
                  <button nz-button nzType="default" style="border-radius: 5px" 
                    (click)="openDialogChooseIcon()"
                    [disabled]="!config['icon']['disable']">
                    {{'thay_doi' | translate}}
                  </button>
                </div>
                <!-- Kích thước icon -->
                <div class="mb-4">
                  <div class="config-name">
                    <p>{{'kich_thuoc' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="50"
                      [nzDisabled]="!config['icon']['disable']"
                      [ngModel]="class['multi-language__icon']['font-size'] | vhnumber" 
                      (ngModelChange)="
                        class['multi-language__icon']['font-size'] = $event + 'px';
                        class['multi-language__icon'].width = $event + 'px';
                        class['multi-language__icon'].height = $event + 'px'
                      "
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <div>
                    <nz-slider [nzMin]="10" [nzMax]="50" 
                      [nzDisabled]="!config['icon']['disable']"
                      [ngModel]="class['multi-language__icon']['font-size'] | vhnumber" 
                      (ngModelChange)="
                        class['multi-language__icon']['font-size'] = $event + 'px';
                        class['multi-language__icon'].width = $event + 'px';
                        class['multi-language__icon'].height = $event + 'px'
                      "
                      (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </div>
                </div>
                <!-- Màu sắc icon -->
                <div class="config-name">
                  <p>{{'mau_sac' | translate}}</p>
                  <div>
                    <input class="input-color" type="button"
                      [cpOKButton]="true" 
                      [disabled]="!config['icon']['disable']"
                      [style.background]="class['multi-language__icon']['color']"
                      [(colorPicker)]="class['multi-language__icon']['color']"
                      (colorPickerClose)="updateClass()" />
                  </div>
                </div>
                <!-- Khoảng cách giữa chữ và lá cờ với biểu tượng -->
                <div *ngIf="config.toggle.flag.disable || config.toggle.content.disable"
                class="d-flex flex-row justify-content-between align-items-center mb-2">
                  <p style="margin:0">{{ 'khoang_cach_giua_chu_va_la_co_so_voi_bieu_tuong' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['multi-language__toggle--inner']['gap'] | vhnumber"
                    (ngModelChange)="class['multi-language__toggle--inner']['gap'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="config.toggle.flag.disable && config.toggle.content.disable">
              <!-- Khoảng cách giữa chữ và lá cờ -->
              <div class="d-flex flex-row justify-content-between align-items-center" >
                <p style="margin:0">{{ 'khoang_cach_giua_chu_va_la_co' | translate }}:</p>
                <nz-input-number [nzMin]="1" [nzMax]="50"
                  [ngModel]="class['multi-language__toggle--inner']['gap'] | vhnumber"
                  (ngModelChange)="class['multi-language__toggle--inner']['gap'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
            </ng-container>

            <ng-container *ngIf="config.toggle.flag.disable">
              <!-- Cấu hình lá cờ -->
              <hr style="border-top: 1px solid rgb(223 223 223)" />
              <p style="font-weight: 500; margin: 16px 0 8px 0;">{{ 'cau_hinh_la_co' | translate }}</p>
              <li nz-submenu nzTitle="{{'kich_thuoc' | translate}}" [(nzOpen)]="openMapSub.submenu9" (nzOpenChange)="openHandler('submenu9')">
                <div class="d-flex flex-row justify-content-between align-items-center" >
                  <p style="margin:0">{{ 'chieu_rong' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['toggle__flag-wrapper']['width'] | vhnumber"
                    (ngModelChange)="class['toggle__flag-wrapper']['width'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <div class="d-flex flex-row justify-content-between align-items-center mt-2" >
                  <p style="margin:0">{{ 'chieu_cao' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['toggle__flag-wrapper']['height'] | vhnumber"
                    (ngModelChange)="class['toggle__flag-wrapper']['height'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'khoang_le' | translate}}" [(nzOpen)]="openMapSub.submenu10" (nzOpenChange)="openHandler('submenu10')">
                <app-margin-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classMargin]="class['toggle__flag-wrapper']" [marginConfigs]="[
                    { type: 'top' },
                    { type: 'bottom' },
                    { type: 'right' }
                  ]">
                </app-margin-config>
              </li>
              <li nz-submenu nzTitle="{{'vien_va_bo_goc' | translate}}" [(nzOpen)]="openMapSub.submenu11" (nzOpenChange)="openHandler('submenu11')">
                <!-- Viền -->
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['toggle__flag-wrapper']" [id_object]="objectChoosing._id">
                </app-borders-config>

                <!-- Bo góc -->
                <hr style="border-top: 1px solid rgb(223 223 223)" />
                <p style="font-weight: 500; margin: 16px 0 8px 0;">{{ 'bo_goc' | translate }}</p>
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['toggle__flag-wrapper']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>
              <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu12" (nzOpenChange)="openHandler('submenu12')">
                <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['toggle__flag-wrapper']"
                  [shadowConfig]="config.toggle.flag['box-shadow']" [objectChoosing]="objectChoosing">
                </app-shadow-config>
              </li>
              <hr style="border-top: 1px solid rgb(223 223 223)" />
            </ng-container>
          
            <!-- Cấu hình hiệu ứng ngôn ngữ đã chọn -->
            <div nz-submenu nzTitle="{{'hieu_ung_ngon_ngu_da_chon' | translate}}" [(nzOpen)]="openMapSub.submenu21" (nzOpenChange)="openHandler('submenu21')">
              <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
                [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
                [cursorClass]="class['multi-language']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
                [effectFileUsing]="'multi-language'">
              </app-choose-animations-config>
            </div>
          </div>
        </li>

        <!-- Cấu hình hộp thoại-->
        <li nz-submenu nzTitle="{{'cau_hinh_hop_thoai' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <div class="editor-field">
            <div class="d-flex flex-row justify-content-between align-items-center" >
              <p style="margin:0">{{ 'chieu_cao_toi_da' | translate }}:</p>
              <nz-input-number [nzMin]="1"
                [ngModel]="class['multi-language__modal']['max-height'] | vhnumber"
                (ngModelChange)="class['multi-language__modal']['max-height'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <div class="d-flex flex-row justify-content-between align-items-center mt-2" >
              <p style="margin:0">{{ 'khoang_cach_giua_cac_muc' | translate }}:</p>
              <nz-input-number [nzMin]="1" [nzMax]="50"
                [ngModel]="class['multi-language__modal']['gap'] | vhnumber"
                (ngModelChange)="class['multi-language__modal']['gap'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>

            <div nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMapSub.submenu6" (nzOpenChange)="openHandler('submenu6')">
              <div class="color-pick">
                <span class="title w-50">{{'mau_nen_hop_thoai' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['multi-language__modal']['background-color']"
                  [style.background]="class['multi-language__modal']['background-color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['modal'].gradient_check"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
                />
              </div>
              <div class="mr-2 mb-3 mt-3 view-more" style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  gap: 7px;
                ">
                <p class="discover_text" (click)="openViewAll(styles_field[2])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
              <div class="color-pick">
                <span class="title w-50">{{'mau_nen_muc_hop_thoai' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['multi-language__modal--item-wrapper']['background-color']"
                  [style.background]="class['multi-language__modal--item-wrapper']['background-color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['modal_item']?.gradient_check"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
                />
              </div>
              <div class="mr-2 mb-3 mt-3 view-more" style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  gap: 7px;
                ">
                <p class="discover_text" (click)="openViewAll(styles_field[5])"
                  style="cursor: pointer; text-align: left; margin: 0">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </div>
            <!-- Cấu hình hình dạng viền của hộp thoại -->
            <div nz-submenu nzTitle="{{'kieu_vien_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu7" (nzOpenChange)="openHandler('submenu7')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['multi-language__modal']" [id_object]="objectChoosing._id">
              </app-borders-config>

              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[3])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </div>

            <!-- Cấu hình hình dạng viền riêng cho từng mục trong hộp thoại -->
            <div nz-submenu nzTitle="{{'kieu_vien_muc' | translate}}" [(nzOpen)]="openMapSub.submenu18" (nzOpenChange)="openHandler('submenu18')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['multi-language__modal--item-wrapper']" [id_object]="objectChoosing._id">
              </app-borders-config>

              <!-- Nút mở rộng -->
              <div class="item-border my-3" style="float: right; cursor: pointer;">
                <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[4])">
                  {{'mo_rong' | translate}} &#8594;
                </p>
              </div>
            </div>

            <li nz-submenu nzTitle="{{'khoang_dem_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu19" (nzOpenChange)="openHandler('submenu19')">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['multi-language__modal']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'right' },
                  { type: 'left' }
                ]">
              </app-padding-config>
            </li>
            <li nz-submenu nzTitle="{{'khoang_dem_muc_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu20" (nzOpenChange)="openHandler('submenu20')">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['multi-language__modal--item-wrapper']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'right' },
                  { type: 'left' }
                ]">
              </app-padding-config>
            </li>

            <div nz-submenu nzTitle="{{'dinh_dang_noi_dung' | translate}}" [(nzOpen)]="openMapSub.submenu8" (nzOpenChange)="openHandler('submenu8')">
              <div class="config-name mb-4">
                <p>{{'flag' | translate}}</p>
                <nz-switch [(ngModel)]="config.modal.flag.disable" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>
      
              <div class="config-name mb-4">
                <p>{{'noi_dung' | translate}}</p>
                <nz-switch [(ngModel)]="config.modal.content.disable" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>

              <ng-container *ngIf="config.modal.content.disable" >
                <div class="config-name">
                  <!-- Font-family -->
                  <div style="width:65%">
                    <mat-form-field>
                      <mat-label>{{ 'kieu_chu' | translate }}</mat-label>
                      <mat-select [(value)]="class['multi-language__modal--item']['font-family']"
                        [(ngModel)]="class['multi-language__modal--item']['font-family']" 
                        (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div style="width:35%">
                    <mat-form-field >
                      <mat-label>{{ 'kich_thuoc' | translate }}</mat-label>
                      <input matInput type="number" 
                        [ngModel]="class['multi-language__modal--item']['font-size'] | vhnumber"
                        (ngModelChange)="class['multi-language__modal--item']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'dinh_dang' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button 
                      [nzType]="class['multi-language__modal--item']['font-weight'] == 'bold' ? 'primary': 'default'" 
                      (click)=" class['multi-language__modal--item']['font-weight'] = class['multi-language__modal--item']['font-weight'] == 'bold' ? '400' : 'bold'; updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                      [nzType]="class['multi-language__modal--item']['font-style'] == 'italic'? 'primary': 'default'" 
                      (click)="class['multi-language__modal--item']['font-style'] = class['multi-language__modal--item']['font-style'] == 'normal' ? 'italic': 'normal'; updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                      [nzType]="class['multi-language__modal--item']['text-decoration'] == 'underline'? 'primary': 'default'" 
                      (click)="class['multi-language__modal--item']['text-decoration'] = class['multi-language__modal--item']['text-decoration'] == 'none' ? 'underline': 'none'; updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button 
                      [nzType]="class['multi-language__modal--item']['text-transform'] == 'uppercase'? 'primary': 'default'" 
                      (click)="class['multi-language__modal--item']['text-transform'] = class['multi-language__modal--item']['text-transform'] == 'none' ? 'uppercase': 'none'; updateClass()">
                      <span>AB</span>
                    </button>
                    <!-- Màu chữ -->
                    <div>
                      <input id="color" type="button" 
                        [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                        [cpOKButton]="true" 
                        [(colorPicker)]="class['multi-language__modal--item']['color']"
                        [style.background]="class['multi-language__modal--item']['color']"
                        (colorPickerClose)="updateClass()" />
                    </div>
                  </div>
                </div>
                <!-- Canh lề -->
                <div class="my-4">
                  <p>{{'canh_le' | translate}}</p>
                  <div class="font">
                    <!-- Lề trái -->
                    <button nz-button class="align-button" title="flex-start" 
                      [nzType]="class['multi-language__modal--item']['text-align'] === 'left'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__modal--item']['text-align'] = 'left'; updateClass()">
                      <i nz-icon nzType="align-left" nzTheme="outline"></i>
                    </button>
                    <!-- Canh giữa -->
                    <button nz-button class="align-button" title="center"
                      [nzType]="class['multi-language__modal--item']['text-align'] === 'center'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__modal--item']['text-align'] = 'center'; updateClass()">
                      <i nz-icon nzType="align-center" nzTheme="outline"></i>
                    </button>
                    <!-- Lề phải -->
                    <button nz-button class="align-button" title="flex-end"
                      [nzType]="class['multi-language__modal--item']['text-align'] === 'right'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__modal--item']['text-align'] = 'right'; updateClass()">
                      <i nz-icon nzType="align-right" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="config.modal.flag.disable">
              <hr style="border-top: 1px solid rgb(223 223 223)" />
              <p style="font-weight: 500; margin: 16px 0 8px 0;">{{ 'cau_hinh_la_co' | translate }}</p>
              <li nz-submenu nzTitle="{{'kich_thuoc' | translate}}" [(nzOpen)]="openMapSub.submenu14" (nzOpenChange)="openHandler('submenu14')">
                <div class="d-flex flex-row justify-content-between align-items-center" >
                  <p style="margin:0">{{ 'chieu_rong' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['modal__flag-wrapper']['width'] | vhnumber"
                    (ngModelChange)="class['modal__flag-wrapper']['width'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <div class="d-flex flex-row justify-content-between align-items-center mt-2" >
                  <p style="margin:0">{{ 'chieu_cao' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['modal__flag-wrapper']['height'] | vhnumber"
                    (ngModelChange)="class['modal__flag-wrapper']['height'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'vien_va_bo_goc' | translate}}" [(nzOpen)]="openMapSub.submenu16" (nzOpenChange)="openHandler('submenu16')">
                <!-- Viền -->
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['modal__flag-wrapper']" [id_object]="objectChoosing._id">
                </app-borders-config>
                
                <!-- Bo góc -->
                <hr style="border-top: 1px solid rgb(223 223 223)" />
                <p style="font-weight: 500; margin: 16px 0 8px 0;">{{ 'bo_goc' | translate }}</p>
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['modal__flag-wrapper']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>
              <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu17" (nzOpenChange)="openHandler('submenu17')">
                <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['modal__flag-wrapper']"
                  [shadowConfig]="config.modal.flag['box-shadow']" [objectChoosing]="objectChoosing">
                </app-shadow-config>
              </li>
              <hr style="border-top: 1px solid rgb(223 223 223)" />
            </ng-container>

            <!-- Cấu hình hiệu ứng hộp thoại -->
            <div nz-submenu nzTitle="{{'hieu_ung_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu22" (nzOpenChange)="openHandler('submenu22')">
              <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetailChild)="openAnimationDetailChild($event)"
                [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
                [cursorClass]="class['multi-language__modal']" [cursorClass2]="class['multi-language__modal--item-wrapper']"
                [titleCursor]="{ cursor1: 'con_tro_cua_hop_thoai', cursor2: 'con_tro_cua_tung_muc_trong_hop_thoai' }"
                [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [isParent]="false" [effectFileUsing]="'multi-language'">
              </app-choose-animations-config>
            </div>

            <!-- Cấu hình hiệu ứng xuất hiện hộp thoại -->
            <div nz-submenu nzTitle="{{'hieu_ung_xuat_hien_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu23"
            (nzOpenChange)="openAnimationAppear(); openHandler('submenu23')">
              <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata"
                [id_object]="objectChoosing._id" [customize]="customize" [device]="device">
              </app-animations-config>
            </div>
          </div>
        </li>
      </ng-container>

      <!-- Danh sách -->
      <ng-container *ngIf="config.display_type == 'list'">
        <!-- Cấu hình danh sách-->
        <li nz-submenu nzTitle="{{'danh_sach' | translate}}"
          [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')"
        >
          <div class="editor-field">
            <div class="d-flex flex-row justify-content-between align-items-center">
              <p style="margin:0">{{ 'khoang_cach_giua_cac_muc' | translate }}:</p>
              <nz-input-number [nzMin]="0" [nzMax]="50"
                [ngModel]="class['multi-language__list']['gap'] | vhnumber"
                (ngModelChange)="class['multi-language__list']['gap'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>

            <div class="d-flex flex-row justify-content-between align-items-center mt-2">
              <p style="margin:0">{{ 'ky_hieu_dau_dong' | translate }}:</p>
              <nz-switch [ngModel]="config.show_dot_list"
              (ngModelChange)="config.show_dot_list = $event; updateConfig()">
              </nz-switch>
            </div>

            <ng-container *ngIf="config.show_dot_list">
              <div class="mt-2">
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <p style="margin:0">{{ 'vi_tri' | translate }}:</p>
                  <nz-input-number [nzMin]="-50" [nzMax]="50"
                    [ngModel]="class['multi-language__list--item-dot']['left'] | vhnumber"
                    (ngModelChange)="class['multi-language__list--item-dot']['left'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-row>
                  <nz-col nzSpan="24">
                    <nz-slider [nzMin]="-50" [nzMax]="50"
                    [ngModel]="class['multi-language__list--item-dot']['left'] | vhnumber"
                    (ngModelChange)="class['multi-language__list--item-dot']['left'] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()">
                    </nz-slider>
                  </nz-col>
                </nz-row>
              </div>
              <div class="d-flex flex-row justify-content-between align-items-center mt-2">
                <p style="margin:0">{{ 'chieu_rong' | translate }}:</p>
                <nz-input-number [nzMin]="1" [nzMax]="50"
                  [ngModel]="class['multi-language__list--item-dot']['width'] | vhnumber"
                  (ngModelChange)="class['multi-language__list--item-dot']['width'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <div class="d-flex flex-row justify-content-between align-items-center mt-2">
                <p style="margin:0">{{ 'chieu_cao' | translate }}:</p>
                <nz-input-number [nzMin]="1" [nzMax]="50"
                  [ngModel]="class['multi-language__list--item-dot']['height'] | vhnumber"
                  (ngModelChange)="class['multi-language__list--item-dot']['height'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <div class="color-pick">
                <span class="title w-50">{{'mau' | translate}}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['multi-language__list--item-dot']['background-color']"
                  [style.background]="class['multi-language__list--item-dot']['background-color']"
                  (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
                />
              </div>
              <!-- Cấu hình hình dạng viền -->
              <div nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMapSub.submenu3" (nzOpenChange)="openHandler('submenu3')">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['multi-language__list--item-dot']" [id_object]="objectChoosing._id">
                </app-borders-config>
              </div>
              <!-- Cấu hình bo goc -->
              <div nz-submenu nzTitle="{{'bo_goc' | translate}}" [(nzOpen)]="openMapSub.submenu4" (nzOpenChange)="openHandler('submenu4')">
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['multi-language__list--item-dot']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </div>
            </ng-container>

            <!-- Cấu hình hiệu ứng hộp thoại -->
            <!-- <div nz-submenu nzTitle="{{'hieu_ung_hop_thoai' | translate}}" [(nzOpen)]="openMapSub.submenu22" (nzOpenChange)="openHandler('submenu22')">
              <app-choose-animations-config [elementChoosing]="objectChoosing" (openAnimationDetailChild)="openAnimationDetailChild($event)"
                [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
                [cursorClass]="class['multi-language__modal']" [cursorClass2]="class['multi-language__modal--item-wrapper']"
                [titleCursor]="{ cursor1: 'con_tro_cua_hop_thoai', cursor2: 'con_tro_cua_tung_muc_trong_hop_thoai' }"
                [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [isParent]="false" [effectFileUsing]="'multi-language'">
              </app-choose-animations-config>
            </div> -->
          </div>
        </li>
        <!-- Cấu hình từng mục-->
        <li nz-submenu nzTitle="{{'tung_muc' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <!-- Cấu hình màu nền của button -->
          <div class="color-pick">
            <span class="title w-50">{{'mau_nen' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['multi-language__list--item-wrapper']['background-color']"
              [style.background]="class['multi-language__list--item-wrapper']['background-color']"
              (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
            />
          </div>
          <ng-container>
            <!-- Cấu hình hình dạng viền -->
            <div nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMapSub.submenu3" (nzOpenChange)="openHandler('submenu3')">
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['multi-language__list--item-wrapper']" [id_object]="objectChoosing._id">
              </app-borders-config>
            </div>
            <!-- Cấu hình bo goc -->
            <div nz-submenu nzTitle="{{'bo_goc' | translate}}" [(nzOpen)]="openMapSub.submenu3" (nzOpenChange)="openHandler('submenu3')">
              <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['multi-language__list--item-wrapper']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>
            </div>
            <!-- Cấu hình khoảng đệm -->
            <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMapSub.submenu19" (nzOpenChange)="openHandler('submenu19')">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['multi-language__list--item-wrapper']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'right' },
                  { type: 'left' }
                ]">
              </app-padding-config>
            </li>
            <!-- Cấu hình định dạng nội dung -->
            <div nz-submenu nzTitle="{{'dinh_dang_noi_dung' | translate}}" [(nzOpen)]="openMapSub.submenu8" (nzOpenChange)="openHandler('submenu8')">
              <div class="config-name mb-4">
                <p>{{'flag' | translate}}</p>
                <nz-switch [(ngModel)]="config.modal.flag.disable" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>
      
              <div class="config-name mb-4">
                <p>{{'noi_dung' | translate}}</p>
                <nz-switch [(ngModel)]="config.modal.content.disable" 
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>

              <ng-container *ngIf="config.modal.content.disable" >
                <div class="config-name">
                  <!-- Font-family -->
                  <div style="width:65%">
                    <mat-form-field>
                      <mat-label>{{ 'kieu_chu' | translate }}</mat-label>
                      <mat-select [(value)]="class['multi-language__list--item']['font-family']"
                        [(ngModel)]="class['multi-language__list--item']['font-family']" 
                        (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div style="width:35%">
                    <mat-form-field >
                      <mat-label>{{ 'kich_thuoc' | translate }}</mat-label>
                      <input matInput type="number" 
                        [ngModel]="class['multi-language__list--item']['font-size'] | vhnumber"
                        (ngModelChange)="class['multi-language__list--item']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'dinh_dang' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button 
                      [nzType]="class['multi-language__list--item']['font-weight'] == 'bold' ? 'primary': 'default'" 
                      (click)=" class['multi-language__list--item']['font-weight'] = class['multi-language__list--item']['font-weight'] == 'bold' ? '400' : 'bold'; updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button 
                      [nzType]="class['multi-language__list--item']['font-style'] == 'italic'? 'primary': 'default'" 
                      (click)="class['multi-language__list--item']['font-style'] = class['multi-language__list--item']['font-style'] == 'normal' ? 'italic': 'normal'; updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button 
                      [nzType]="class['multi-language__list--item']['text-decoration'] == 'underline'? 'primary': 'default'" 
                      (click)="class['multi-language__list--item']['text-decoration'] = class['multi-language__list--item']['text-decoration'] == 'none' ? 'underline': 'none'; updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button 
                      [nzType]="class['multi-language__list--item']['text-transform'] == 'uppercase'? 'primary': 'default'" 
                      (click)="class['multi-language__list--item']['text-transform'] = class['multi-language__list--item']['text-transform'] == 'none' ? 'uppercase': 'none'; updateClass()">
                      <span>AB</span>
                    </button>
                    <!-- Màu chữ -->
                    <div>
                      <input id="color" type="button" 
                        [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                        [cpOKButton]="true" 
                        [(colorPicker)]="class['multi-language__list--item']['color']"
                        [style.background]="class['multi-language__list--item']['color']"
                        (colorPickerClose)="updateClass()" />
                    </div>
                  </div>
                </div>
                <!-- Canh lề -->
                <div class="my-4">
                  <p>{{'canh_le' | translate}}</p>
                  <div class="font">
                    <!-- Lề trái -->
                    <button nz-button class="align-button" title="flex-start" 
                      [nzType]="class['multi-language__list--item']['text-align'] === 'left'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__list--item']['text-align'] = 'left'; updateClass()">
                      <i nz-icon nzType="align-left" nzTheme="outline"></i>
                    </button>
                    <!-- Canh giữa -->
                    <button nz-button class="align-button" title="center"
                      [nzType]="class['multi-language__list--item']['text-align'] === 'center'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__list--item']['text-align'] = 'center'; updateClass()">
                      <i nz-icon nzType="align-center" nzTheme="outline"></i>
                    </button>
                    <!-- Lề phải -->
                    <button nz-button class="align-button" title="flex-end"
                      [nzType]="class['multi-language__list--item']['text-align'] === 'right'
                        ? 'primary'
                        : 'default'" 
                      (click)="class['multi-language__list--item']['text-align'] = 'right'; updateClass()">
                      <i nz-icon nzType="align-right" nzTheme="outline"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
            <!-- Cấu hình lá cờ -->
            <ng-container *ngIf="config.modal.flag.disable">
              <hr style="border-top: 1px solid rgb(223 223 223)" />
              <p style="font-weight: 500; margin: 16px 0 8px 0;">{{ 'cau_hinh_la_co' | translate }}</p>
              <li nz-submenu nzTitle="{{'kich_thuoc' | translate}}" [(nzOpen)]="openMapSub.submenu14" (nzOpenChange)="openHandler('submenu14')">
                <div class="d-flex flex-row justify-content-between align-items-center" >
                  <p style="margin:0">{{ 'chieu_rong' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['modal__flag-wrapper']['width'] | vhnumber"
                    (ngModelChange)="class['modal__flag-wrapper']['width'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <div class="d-flex flex-row justify-content-between align-items-center mt-2" >
                  <p style="margin:0">{{ 'chieu_cao' | translate }}:</p>
                  <nz-input-number [nzMin]="1" [nzMax]="50"
                    [ngModel]="class['modal__flag-wrapper']['height'] | vhnumber"
                    (ngModelChange)="class['modal__flag-wrapper']['height'] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'vien_va_bo_goc' | translate}}" [(nzOpen)]="openMapSub.submenu16" (nzOpenChange)="openHandler('submenu16')">
                <!-- Viền -->
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['modal__flag-wrapper']" [id_object]="objectChoosing._id">
                </app-borders-config>
                
                <!-- Bo góc -->
                <hr style="border-top: 1px solid rgb(223 223 223)" />
                <p style="font-weight: 500; margin: 16px 0 8px 0;">{{ 'bo_goc' | translate }}</p>
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['modal__flag-wrapper']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>
              <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMapSub.submenu17" (nzOpenChange)="openHandler('submenu17')">
                <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['modal__flag-wrapper']"
                  [shadowConfig]="config.modal.flag['box-shadow']" [objectChoosing]="objectChoosing">
                </app-shadow-config>
              </li>
              <hr style="border-top: 1px solid rgb(223 223 223)" />
            </ng-container>
          </ng-container>
        </li>
        <!-- Cấu hình ngôn ngữ đã chọn-->
        <li nz-submenu nzTitle="{{'muc_ngon_ngu_da_chon' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
          <!-- Cấu hình màu nền của button -->
          <div class="color-pick">
            <span class="title w-50">{{'mau_nen' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="config.active_style.background_color"
              [style.background]="config.active_style.background_color"
              (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
            />
          </div>
          <!-- Cấu hình màu chữ của button -->
          <div class="color-pick mt-2">
            <span class="title w-50">{{'mau_chu' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="config.active_style.color"
              [style.background]="config.active_style.color"
              (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)" 
            />
          </div>
        </li>
      </ng-container>
      
      <li nz-submenu nzTitle="{{'chinh_sua_noi_dung' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <div>
          <p class="m-0 mb-1" style="font-size: 16px; font-weight: 500;">
            {{'danh_sach_ten_thay_the_cho_ngon_ngu' | translate}}
          </p>
          <ul>
            <li *ngFor="let item of functionService.multi_languages" style="line-height: 1.5;">
              <span>-- {{ item.name }}</span>
              <span *ngIf="staticdata.lang_name?.[item.code]?.name; else defaultEditContent">
                : {{ staticdata.lang_name?.[item.code]?.name }}
              </span>

              <ng-template #defaultEditContent>
                <span>: ({{ 'mac_dinh' | translate }})</span>
              </ng-template>
            </li>
          </ul>
        </div>
        <div class="mt-3">
          <p class="m-0 mb-1" style="font-size: 16px; font-weight: 500;">
            {{ 'chon_ngon_ngu_de_chinh_sua' | translate }}
          </p>
          <nz-select [(ngModel)]="codeEditLangName">
            <nz-option *ngFor="let lang of functionService.multi_languages"
            [nzValue]="lang.code" [nzLabel]="lang.name | translate"></nz-option>
          </nz-select>
          <mat-form-field class="mt-1" style="width: 100%;">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput style="height: 50px;"
              [ngModel]="staticdata.lang_name?.[codeEditLangName]?.name"
              (ngModelChange)="staticdata.lang_name[codeEditLangName].name = $event"
              (blur)="updateStaticData();"
            ></textarea>
          </mat-form-field>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 0">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['toggle'].gradient_check" (ngModelChange)="updateBackgroundRgb('multi-language', 'toggle')"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="let bgGradient of config['toggle']['gradient_arr']; let i = index" 
          (click)="deleteGradient(i,'multi-language', 'toggle')" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="!config['toggle'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['multi-language']['toggle']"
          type="button" [disabled]="!config['toggle'].gradient_check"
          [style.background]="class['multi-language']['toggle']" (colorPickerClose)="addGradient($event,'multi-language', 'toggle')" 
        />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
        nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, 'multi-language', 'toggle')"
        [disabled]="!config['toggle'].gradient_check" [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config['toggle'].gradient_direction === type.direction">
      </button>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['multi-language']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 2">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['modal'].gradient_check" (ngModelChange)="updateBackgroundRgb('multi-language__modal', 'modal')"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="let bgGradient of config['modal']['gradient_arr']; let i = index" 
          (click)="deleteGradient(i, 'multi-language__modal', 'modal')" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="!config['modal'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['multi-language__modal']['modal']"
          type="button" [disabled]="!config['modal'].gradient_check"
          [style.background]="class['multi-language__modal']['modal']" (colorPickerClose)="addGradient($event, 'multi-language__modal', 'modal')" 
        />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
        nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, 'multi-language__modal', 'modal')"
        [disabled]="!config['modal'].gradient_check" [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config['modal'].gradient_direction === type.direction">
      </button>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['multi-language__modal']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['multi-language__modal--item-wrapper']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 5">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [ngModel]="config['modal_item']?.gradient_check"
        (ngModelChange)="config['modal_item'].gradient_check = $event; updateBackgroundRgb('multi-language__modal--item-wrapper', 'modal_item')">
        </label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="let bgGradient of config['modal_item']['gradient_arr']; let i = index" 
          (click)="deleteGradient(i, 'multi-language__modal--item-wrapper', 'modal_item')" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="!config['modal_item'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['multi-language__modal--item-wrapper']['modal_item']"
          type="button" [disabled]="!config['modal_item'].gradient_check"
          [style.background]="class['multi-language__modal--item-wrapper']['modal_item']" (colorPickerClose)="addGradient($event, 'multi-language__modal--item-wrapper', 'modal_item')" 
        />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
        nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event, 'multi-language__modal--item-wrapper', 'modal_item')"
        [disabled]="!config['modal_item'].gradient_check" [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"
        [class.active]="config['modal_item'].gradient_direction === type.direction">
      </button>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 6 || currentViewAll.index == 7 ">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device" [isParent]="currentViewAll.index == 6"></app-animations-config>
    </div>
  </div>
</div>
